import { useBreakpointValue } from "@gemini/core";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";

import { BRAND_CONFIGURATION } from "../../../../configs/brands";

import { BottomCustomBanner } from "./variants/BottomCustomBanner";
import { PersistentCustomBanner } from "./variants/PersistentCustomBanner";
import { useCustomBanner } from "./useCustomBanner";

const { appBanner } = BRAND_CONFIGURATION;

const componentByVariant = {
  bottom: BottomCustomBanner,
  persistent: PersistentCustomBanner,
};

export const CustomBanner = () => {
  const isSmallViewport = useBreakpointValue({
    base: true,
    md: false,
  });

  const {
    application: { id: applicationId },
  } = useEnvironment();

  const variant = isSmallViewport ? "bottom" : "persistent";

  const { isBannerVisible, onClick, onDismiss } = useCustomBanner({
    variant,
  });

  const bannerInfo = applicationId ? appBanner?.custom?.[applicationId] : null;

  if (isBannerVisible === null || !bannerInfo) return null;

  const CustomBannerComponent = componentByVariant[variant];

  return (
    <CustomBannerComponent
      bannerInfo={bannerInfo}
      isBannerVisible={isBannerVisible}
      onClick={onClick}
      onDismiss={onDismiss}
    />
  );
};
